import React from "react";

import { OnlineCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function online({ width, onResize }: Column.Options) {
	return base(ColumnId.Online, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default online;
